export default __webpack_public_path__ + "static/img-gate-bda2d9c702a1f96fb01bdc373f2ae758.png";